import { Theme } from '@mui/material/styles';
import { SxProps } from "@mui/system";

export const dialogTitleStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    pr: 4,
    pb: 3
};

export const closeIconStyles: SxProps<Theme> = { position: 'absolute', right: 8, top: 8 };
export const dialogActionsStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'space-between',
    px: 3,
    pb: 2
};